module.exports = __webpack_public_path__ + "img/mobile_logo.5183cfcd.png";